import GoogleDocument from '../assets/google-document-types/google-apps-document.svg';
import GoogleSpreadsheet from '../assets/google-document-types/google-apps-spreadsheet.svg';
import GooglePresentation from '../assets/google-document-types/google-apps-presentation.svg';
import GoogleAudio from '../assets/google-document-types/google-apps-audio.svg';
import GoogleVideo from '../assets/google-document-types/google-apps-video.svg';
import GooglePhoto from '../assets/google-document-types/google-apps-images.svg';
import GooglePDF from '../assets/google-document-types/google-apps-pdf.svg';
import GoogleDrawing from '../assets/google-document-types/google-apps-drawing.svg';
import GoogleForm from '../assets/google-document-types/google-apps-form.svg';
import GoogleScript from '../assets/google-document-types/google-apps-script.svg';
import GoogleSites from '../assets/google-document-types/google-apps-sites.svg';
import GoogleFusionTable from '../assets/google-document-types/google-apps-fusion-table.svg';
import GoogleFile from '../assets/google-document-types/google-apps-file.svg';
import GoogleFolder from '../assets/google-document-types/google-apps-folder.svg';
import GoogleUnknown from '../assets/google-document-types/google-apps-file.svg';

export const documentTypeOptions = [
  {
    value: 'application/vnd.google-apps.document',
    displayValue: 'Google Document',
    icon: GoogleDocument,
  },
  {
    value: 'application/vnd.google-apps.spreadsheet',
    displayValue: 'Google Spreadsheet',
    icon: GoogleSpreadsheet,
  },
  {
    value: 'application/vnd.google-apps.presentation',
    displayValue: 'Google Presentation',
    icon: GooglePresentation,
  },
  {
    value: 'application/vnd.google-apps.drawing',
    displayValue: 'Google Drawing',
    icon: GoogleDrawing,
  },
  {
    value: 'application/vnd.google-apps.form',
    displayValue: 'Google Form',
    icon: GoogleForm,
  },
  {
    value: 'application/vnd.google-apps.script',
    displayValue: 'Google Script',
    icon: GoogleScript,
  },
  {
    value: 'application/vnd.google-apps.folder',
    displayValue: 'Folder',
    icon: GoogleFolder,
  },
  {
    value: 'application/pdf',
    displayValue: 'PDF',
    icon: GooglePDF,
  },
  {
    value: 'application/vnd.google-apps.file',
    displayValue: 'File',
    icon: GoogleFile,
  },
  {
    value: 'application/vnd.google-apps.audio',
    displayValue: 'Audio',
    icon: GoogleAudio,
  },
  {
    value: 'application/vnd.google-apps.video',
    displayValue: 'Video',
    icon: GoogleVideo,
  },
  {
    value: 'application/vnd.google-apps.fusiontable',
    displayValue: 'Fusion Table',
    icon: GoogleFusionTable,
  },
  {
    value: 'application/vnd.google-apps.kix',
    displayValue: 'Kix',
    icon: GoogleUnknown,
  },
  {
    value: 'application/vnd.google-apps.photo',
    displayValue: 'Photo',
    icon: GooglePhoto,
  },
  {
    value: 'application/vnd.google-apps.site',
    displayValue: 'Google Sites',
    icon: GoogleSites,
  },
  {
    value: 'application/vnd.google-apps.unknown',
    displayValue: 'Unknown',
    icon: GoogleUnknown,
  },
];
